import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import {
  GET_RESULT_SUBMIT,
  GET_REPORT,
  GET_SERELOGY_RESULT,
  GET_QUALITATIVE_SUMMARY,
  GET_MICRO_REPORT,
} from "./actionTypes";

import {
  getResultSubmitSuccess,
  getResultSubmitFail,
  getReportSuccess,
  getReportFail,
  getSereologyResultSuccess,
  getSereologyResultFail,
  getQualitativeSummarySuccess,
  getQualitativeSummaryFail,
  // ✅ New Micro Report Actions
  getReportMicroSuccess,
  getReportMicroFail,
} from "./actions";

// Include Both Helper File with needed methods
import {
  getResultSubmit,
  getReport,
  getSereologyResult,
  // ✅ Add Micro Report API helper
  getMicroReport,
  getQualitativeSummary,
} from "../../helpers/django_api_helper";

////////////////
// Result Submit
function* fetchResultList(object) {
  try {
    const response = yield call(getResultSubmit, object.payload);
    yield put(getResultSubmitSuccess(response.data));
  } catch (error) {
    yield put(getResultSubmitFail(error));
  }
}

function* fetchReport({ payload }) {
  try {
    const { roundId, labId } = payload; 
    console.log("Saga: Fetching report");
    console.log("Round ID:", roundId, "Lab ID:", labId);

    // Call your API
    const response = yield call(getReport, roundId, labId);
    console.log("Saga: API response received:", response);

    if (response && response.participants_results) {
      console.log("Saga: participants_results found, preparing report data");

      const reportData = {
        participants_results: response.participants_results,
        participant_name: response.participant_name,
        analyte_result_summary: response.analyte_result_summary,
        round_name: response.round_name,
        scheme_name: response.scheme_name,
        graph_data: response.graph_data, // <-- graph data included
        issue_date: response.issue_date,
        closing_date: response.closing_date,
        cycle_no: response.cycle_no,
        sample: response.sample,
        matrix: response.matrix || "N/A",
        robust_mean: response.robust_mean,
        round_sample_condition: response.round_sample_condition,
      };

      console.log("Saga: Prepared reportData:", reportData);

      // Check if graph_data is populated
      if (reportData.graph_data && reportData.graph_data.length > 0) {
        console.log("Saga: Graph data exists:", reportData.graph_data);
      } else {
        console.warn("Saga: Graph data is empty or missing");
      }

      yield put(getReportSuccess(reportData));
      console.log("Saga: getReportSuccess dispatched");
    } else {
      console.warn("Saga: No participants_results in API response");
      yield put(getReportFail("No participants data"));
    }
  } catch (error) {
    console.error("Saga: Error fetching report:", error);
    yield put(getReportFail(error));
  }
}


// Serology Report
function* fetchSerologReport(object) {
  try {
    const response = yield call(getSereologyResult, object.payload);
    yield put(getSereologyResultSuccess(response));
  } catch (error) {
    yield put(getSereologyResultFail(error));
  }
}

// ✅ Micro Report

// ✅ Micro Report
function* fetchMicroReport(object) {
  try {
    const response = yield call(getMicroReport, object.payload);

    yield put(getReportMicroSuccess(response));
  } catch (error) {
    yield put(getReportMicroFail(error));
  }
}
function* fetchQualitativeSummary(object) {
  try {
    const response = yield call(getQualitativeSummary, object.payload);

    yield put(getQualitativeSummarySuccess(response));
  } catch (error) {
    yield put(getQualitativeSummaryFail(error));
  }
}
function* ResultSubmitSaga() {
  yield takeEvery(GET_RESULT_SUBMIT, fetchResultList);
  yield takeEvery(GET_REPORT, fetchReport);
  yield takeEvery(GET_SERELOGY_RESULT, fetchSerologReport);
  // ✅ Watch Micro Report
  yield takeEvery(GET_MICRO_REPORT, fetchMicroReport);
  yield takeEvery(GET_QUALITATIVE_SUMMARY, fetchQualitativeSummary);
}

export default ResultSubmitSaga;
